import React from 'react'; // Grid row context

export var GridRowContext = /*#__PURE__*/React.createContext(null);